import { InjectionKey, ComputedRef } from 'vue'

export enum LOGIN_TYPE {
  PASSWORD = 'passwordLogin',
  CAPTCHA = 'captchaLogin',
  FORGET = 'forgetLogin',
}

export const SMS_CODE_TYPE = {
  [LOGIN_TYPE.CAPTCHA]: 2, // 登录
  [LOGIN_TYPE.FORGET]: 3, // 3：设置密码
} as const

export type ISMS_CODE_TYPE = (typeof SMS_CODE_TYPE)[keyof typeof SMS_CODE_TYPE]

export enum AUTHORITY {
  needLogin,
  needFirstSet,
  needChooseTenant,
  ok,
}

export const LOGO = 'https://mogic-static.oss-cn-hangzhou.aliyuncs.com/vida/Group%201000004564.svg'

export const PAGE_LIST_WIDTH_KEY = Symbol('PAGE_LIST_WIDTH_KEY') as InjectionKey<ComputedRef<number>>
